import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HomeIcon from "@material-ui/icons/Home";
import * as React from "react";
import { CompaniesService } from "../services/CompaniesService";
import AddCompanyDialog, { MODE_TYPE } from "../dialogs/AddCompanyDialog";
import ProfileHeadComponent from "../components/ProfileHeadComponent";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import BaseComponent from "../components/BaseComponent";
import { Redirect } from "react-router-dom";

export const TOOL_BAR_BUTTON_TYPES = {
  COMPANY: "COMPANY",
  EMPLOYEE: "EMPLOYEE",
  INSPECTIONS: "INSPECTIONS",
  EQUIPMENTS: "EQUIPMENTS",
  COMPLETED: "COMPLETED",
  VISITORS: "VISITORS",
  TRACING: "TRACING",
  NORMAL: "NORMAL",
};
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  profileData: any;
}
class DashboardScreen extends React.Component<Props> {
  state = {
    register: false,
    showError: false,
    mobileOpen: false,
    openAddCompanyDialog: false,
    companies: [],
    errorMessage: "",

    toolBarData: { title: "", type: "", callBack: null },
    showToolBarButton: false,

    pageTitle: "",

    displayCompanyData: { show: false, data: null },
    showCompanies: false,
    form: {
      email: "",
      password: "",
      fullName: "",
      phoneNumber: "",
    },
  };
  componentDidMount = () => {
    this.getCompanies();
  };

  getCompanies = () => {
    let displayCompanyData = { show: false, data: null };
    let companiesService: CompaniesService = new CompaniesService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    companiesService.getCompanies().then((resp) => {
      if (resp && resp.success && resp.companies) {
        this.setState(
          {
            companies: resp.companies,
            showCompanies: true,
            showToolBarButton: true,
            displayCompanyData: displayCompanyData,
            toolBarData: {
              title: "Companies",
              type: TOOL_BAR_BUTTON_TYPES.COMPANY,
              callBack: this.handleAddCompany,
            },
            pageTitle: "COMPANIES",
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
          }
        );
      } else {
        this.setState({
          showCompanies: false,
          showToolBarButton: false,
        });
        if (resp && resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        }
      }
    });
  };

  onUpdatePage = () => {
    this.getCompanies();
  };

  handleClose = () => {
    this.setState({
      openAddCompanyDialog: false,
      openAddEmployeesDialog: false,
    });
  };
  handleOnSubmit = (values: any) => {
    let companiesService: CompaniesService = new CompaniesService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    companiesService.addCompany(values).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState({ openAddCompanyDialog: false });
        this.getCompanies();
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        this.setState({ isLoading: false });
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: "Oops something happened",
        });
      }
    });
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: true });
  };
  handleAddCompany = () => {
    this.setState({ openAddCompanyDialog: true });
  };
  renderAddCompanyDialog = () => {
    return (
      <AddCompanyDialog
        title={"Add Company"}
        mode={MODE_TYPE.ADD}
        open={this.state.openAddCompanyDialog}
        handleClose={this.handleClose}
        handleOnSubmit={this.handleOnSubmit}
      />
    );
  };
  public responsiveDrawer = () => {
    const { classes, profileData } = this.props;
    return (
      <div>
        <div className={classes.toolbar}></div>
        <Divider />
        <ProfileHeadComponent
          profileData={profileData}
          companies={this.state.companies}
        />
      </div>
    );
  };
  onMenuButtonClicked = () => {
    this.getCompanies();
  };
  renderMenuButton = (styleMenuButton: any, type: String) => {
    return (
      <IconButton
        style={{
          alignSelf: "flex-start",
        }}
        aria-label="open drawer"
        edge="start"
        onClick={() => {
          this.onMenuButtonClicked();
        }}
        className={styleMenuButton}
      >
        {type === "child" && <ArrowBackIcon />}
        {type === "home" && <HomeIcon style={{ color: "grey" }} />}
      </IconButton>
    );
  };

  onCompanyClicked = (event: any, companyData: any) => {
    let displayCompanyData = { show: true, data: companyData };
    this.setState({
      displayCompanyData: displayCompanyData,
      showCompanies: false,
      pageTitle: companyData.name,
    });
  };

  updateToolBarButton = (title: String, type: String, callBack: any) => {
    if (type === TOOL_BAR_BUTTON_TYPES.NORMAL) {
      this.setState({
        toolBarData: { title: title, type: type, callBack: callBack },
        showToolBarButton: false,
      });
    } else {
      this.setState({
        toolBarData: { title: title, type: type, callBack: callBack },
        showToolBarButton: true,
      });
    }
  };

  render() {
    const { profileData } = this.props;
    return (
      <React.Fragment>
        {this.renderAddCompanyDialog()}
        <BaseComponent
          companies={this.state.companies}
          profileData={profileData}
          pageTitle={this.state.pageTitle}
          toolBarData={this.state.toolBarData}
        >
          {this.state.showCompanies && <Redirect to="/segpi/companies" />}
        </BaseComponent>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(DashboardScreen);
